import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'gb-visa-icon',
  templateUrl: './gb-visa-icon.component.html',
  styleUrls: ['./gb-visa-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbVisaIconComponent {
  @Input() darkTheme = false
}
